/* eslint-disable */
import { envDomain } from '@/common/contact-selector/utils/domainConfig';
export default function(params) {
    return new Promise((resolve, reject) => {
        if (params.ids && params.ids.length) {
            //兼容请求需要时number的集合
            let ids = [];
            params.ids.forEach((ele)=>{
                if(typeof ele === 'string'){
                    ids.push(parseFloat(ele));
                }else{
                    ids.push(ele);
                }
            })
            _getQQFriendDetailByUin({
                uins: ids
            }).then(
                res => {
                    const result = {};
                    if (window.parseInt(res.code) === 0 && res.data && res.data.friends) {
                        res.data.friends.forEach(item => {
                            //将返回的数据的uin改为string类型
                            if(typeof(item.uin)==='number'){
                                item.uin = item.uin+'';
                            }
                            item.id = item.uin;
                            result[item.uin] = {
                                name: item.privateRemark || item.name,
                                face: item.face
                            };
                        });
                        resolve(result);
                    } else {
                        reject(res);
                    }
                },
                err => {
                    reject(err);
                }
            );
        } else {
            resolve({});
        }
    });
}
function _getQQFriendDetailByUin(params) {
    return Vue.prototype.$_sAjax.crossPost(`${envDomain.gateway}/b2b/selector/getQQFriendDetailByUin`, params);
}
